import { Flex, styled } from '@chilipiper/design-system'

export const StyledAvatarImage = styled.img<{ size: string; borderRadius: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: ${({ borderRadius }) => borderRadius};
  object-fit: cover;
`

export const StyledOverflowFlex = styled(Flex)`
  scrollbar-gutter: stable;
  overflow: hidden auto;
  overscroll-behavior: contain;
`
